let prevScrollpos = window.pageYOffset;
window.onscroll = function () {
    let currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos || currentScrollPos <= 65) {
        document.querySelector('.header').classList.remove('header--hidden');
    } else {
        document.querySelector('.header').classList.add('header--hidden');
    }
    prevScrollpos = currentScrollPos;
};
